import React from 'react'
import { Text } from 'recharts'
import styled from 'styled-components'

const Container = styled.div`
  font-size: 14px;
`

export default ({ theme, payload: { value }, ...rest }) => (
  <Container as={Text} {...rest} fill={theme.colors.grey1}>
    {value}
  </Container>
)
